import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson13/Answer/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson13/Answer/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson13/Answer/Issue3";
import Issue4 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson13/Answer/Issue4";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson13AnswerProps = {
  materialCode: string;
  lessonNo: number;
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson13Answer = (props: Lesson13AnswerProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(1)}
        />
      </div>
      <div className={styles.section}>
        <Issue2
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(2)}
        />
      </div>
      <div className={styles.section}>
        <Issue3
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(3)}
        />
      </div>
      <div className={styles.section}>
        <Issue4
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(4)}
        />
      </div>
    </>
  );
};
export default Lesson13Answer;
